<template>
  <form v-on:submit="save">
    <div class="card card-info card-tabs">
      <div class="card-header  p-0 pt-1 pl-1">
        <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" href="#tab_1" data-toggle="pill" role="tab" aria-controls="tab_1" aria-selected="true">Students</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#tab_2" data-toggle="pill" role="tab" aria-controls="tab_2" aria-selected="false">Offered Courses</a>
          </li>
        </ul>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class="card-body">
        <div class="tab-content active" id="custom-tabs-four-tabContent">
          <div class="tab-pane fade active show" id="tab_1">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>Program</label>
                  <select class="form-control" v-model="st.ProgramID" v-on:change="loadBatch()" required="required">
                    <option value="0" disabled="disabled">--Select Program--</option>
                    <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>Session</label>
                  <select class="form-control" v-model="st.SessionID" v-on:change="loadStudents()" required="required">
                    <option value="0" disabled="disabled">--Select Session--</option>
                    <option v-for="item in sessions" v-bind:value="item.SessionID">{{item.Name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12" v-show="st.SessionID != 0">

                <div class="form-group">
                  <label>Sections</label>
                  <div v-for="(item, ind) in sections" class="checkbox">
                    <label>
                      <input style="margin-top: 0px;" type="checkbox" v-model="item.Selected" v-on:change="sectionChange(ind)">
                      {{item.Batch}}
                    </label>
                  </div>
                  <div>
                    Selected Students <b>{{students.filter((x) => {return x.Selected;}).length}}</b>
                  </div>
                  <br />
                  <table id="tblStudent" class="table table-sm table-bordered table-color table-hover">
                    <thead class="bg-info">
                      <tr>
                        <th>Roll No.</th>
                        <th>Reg. No.</th>
                        <th>
                          <div class="checkbox">
                            <label>
                              <input style="margin-top: 0px;" type="checkbox" v-model="stcheck" v-on:change="masterCheckStudents()">
                              Student Name
                            </label>
                          </div>
                        </th>
                        <th>Father Name</th>
                        <th>Batch</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in students">
                        <td>{{item.RollNo}}</td>
                        <td>{{item.RegistrationNo}}</td>
                        <td>
                          <div class="checkbox">
                            <label>
                              <input style="margin-top: 0px;" type="checkbox" v-model="item.Selected">
                              {{item.Name}}
                            </label>
                          </div>
                        </td>
                        <td>{{item.FathersName}}</td>
                        <td>{{item.Batch}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab_2">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>Program </label>
                  <select class="form-control" v-model="cr.ProgramID" v-on:change="loadBatchForCourses()" required="required">
                    <option value="0" disabled="disabled">--Select Program--</option>
                    <option v-for="item in allprograms" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>Session</label>
                  <select class="form-control" v-model="cr.SessionID" v-on:change="loadCourses()" required="required">
                    <option value="0" disabled="disabled">--Select Session--</option>
                    <option v-for="item in crssessions" v-bind:value="item.SessionID">{{item.Name}}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6" v-show="cr.SessionID != 0">
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input style="margin-top: 0px;" type="checkbox" v-model="prereq">
                      Check Pre-Requisits
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12" v-show="cr.SessionID != 0">
                <h3 v-if="note == 'Other'" class="text-danger">Note: You selected different program</h3>
                <label>Offered Courses </label>
                <table id="tblCourse" style="width: 100%" class="table table-sm table-bordered table-color">
                  <thead class="bg-info">
                    <tr>
                      <th rowspan="2">Course Code</th>
                      <th rowspan="2">
                        <div class="checkbox">
                          <label>
                            <input style="margin-top: 0px;" type="checkbox" v-model="crcheck" v-on:change="masterCheckCourses()">
                            Course Name
                          </label>
                        </div>
                      </th>
                      <th rowspan="2">Semester</th>
                      <th colspan="3">Credit Hour</th>
                      <th rowspan="2">Course Type</th>
                    </tr>
                    <tr>
                      <th>Theory</th>
                      <th>Lab</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in courses">
                      <td>{{item.CourseCode}}</td>
                      <td>
                        <div class="checkbox">
                          <label>
                            <input style="margin-top: 0px;" type="checkbox" v-model="item.Selected">
                            {{item.CourseName}}
                          </label>
                        </div>
                      </td>
                      <td>{{item.Semester}}</td>
                      <td>{{item.Theory}}</td>
                      <td>{{item.Lab}}</td>
                      <td>{{item.CreditHours}}</td>
                      <td>{{item.Type}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Button -->
      <div class="card-footer">
        <div class="col-md-12">
          <input type="submit" value="Save" class="btn btn-success float-right" />
          <button class="btn btn-danger float-left" type="button" v-on:click="cancel()">Cancel</button>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal-xl" role="dialog">
      <div class="modal-dialog modal-xl" style="width: auto !important">

        <!-- Modal content-->

        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left" style="width: 200px">Summary</h4>
            <!--<%--<button type="button" class=" pull-right btn btn-primary" data-dismiss="modal">Print</button>--%>-->
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="table-responsive">
                    <table id="tblSummary" class="table table-sm table-bordered table-color table-hover">
                      <thead class="bg-info">
                        <tr>
                          <th>Roll No.</th>
                          <th>Reg. No.</th>
                          <th>Student Name</th>
                          <th>Father Name</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in summary">
                          <td>{{item.RollNo}}</td>
                          <td>{{item.RegistrationNo}}</td>
                          <td>
                            {{item.Name}}
                          </td>
                          <td>{{item.FathersName}}</td>
                          <td>
                            <ol>
                              <li v-for="c in item.Summary">
                                <span class="fa fa-check text-success" v-if="c.Active">{{c.Name}} <b>-- {{c.Code}}</b></span>
                                <span class="fa fa-remove text-danger" v-else>{{c.Name}} <b>-- {{c.Code}}</b></span>
                              </li>
                            </ol>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>



      </div>
    </div>
  </form>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        programs: [],
        allprograms: [],
        sessions: [],
        crssessions: [],
        st: { ProgramID: 0, SessionID: 0 },
        cr: { ProgramID: 0, SessionID: 0 },
        students: [],
        courses: [],
        sections: [],
        prereq: false,
        stcheck: true,
        crcheck: false,
        note: '',
        summary: []
      }
    },
    created: function () {
      this.loadPrograms();
    },

    updated: function () {
      $('#tblStudent').DataTable();
      $('#tblCourse').DataTable();
    },
    methods: {
      loadPrograms() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadAllPrograms')
          .then(function (response) {
            if (response.data.status) {

              vm.programs = response.data.prog;
            }

            axios.post('/api/DCApi/loadAllProgramsforcourseenrollment')
              .then(function (p) {
                if (p.data.status) {
                  vm.allprograms = p.data.prog;
                  endReq();
                }

              });

            endReq();
          });
      },

      loadBatch() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadSessions?progID=' + vm.st.ProgramID)
          .then(function (response) {
            if (response.data.status) {
              vm.sessions = response.data.record;
              vm.st.SessionID = 0;
              vm.students = [];
              var table = $('#tblStudent').DataTable();
              table.destroy();
              endReq();
            }

          });
      },

      loadBatchForCourses() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadSessions?progID=' + vm.cr.ProgramID)
          .then(function (response) {
            if (response.data.status) {
              vm.note = vm.allprograms.find(x => x.ProgramID == vm.cr.ProgramID).Text;
              vm.crssessions = response.data.record;
              vm.cr.SessionID = 0;
              vm.courses = [];
              var table = $('#tblCourse').DataTable();
              table.destroy();
              endReq();
            }

          });
      },

      loadStudents() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadStudents?progID=' + vm.st.ProgramID + '&sesID=' + vm.st.SessionID)
          .then(function (response) {
            if (response.data.status) {
              var table = $('#tblStudent').DataTable();
              table.destroy();
              vm.students = response.data.record;
              vm.sections = response.data.sel;

              vm.crssessions = vm.sessions;
              vm.cr.ProgramID = vm.st.ProgramID;
              vm.cr.SessionID = vm.st.SessionID;

              vm.loadCourses();
              endReq();
            }

          });
      },

      loadCourses() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadCourses?progID=' + vm.cr.ProgramID + '&sesID=' + vm.cr.SessionID)
          .then(function (response) {
            if (response.data.status) {
              vm.courses = [];
              var table = $('#tblCourse').DataTable();
              table.destroy();
              vm.courses = response.data.record;
              endReq();
            }

          });
      },

      masterCheckStudents() {
        var vm = this;
        startReq();
        vm.students.forEach(function (item) {
          item.Selected = vm.stcheck
        })
        endReq();
      },

      masterCheckCourses() {
        var vm = this;
        startReq();
        vm.courses.forEach(function (item) {
          item.Selected = vm.crcheck
        })
        endReq();
      },

      sectionChange(ind) {
        var vm = this;
        var ses = vm.sections[ind];
        console.log(ses);
        vm.students.forEach(function (item) {
          if (ses.Selected && item.SectionID == ses.SectionID)
            item.Selected = true;
          else if (!ses.Selected && item.SectionID == ses.SectionID)
            item.Selected = false;
        });
      },


      save(e) {
        e.preventDefault();
        var vm = this;

        var st = vm.students.filter((x) => { return x.Selected; });
        if (st.length == 0) {
          toastr.error("No student selected");
          return;
        }

        var cr = vm.courses.filter((x) => { return x.Selected; });
        if (cr.length == 0) {
          toastr.error("No Course selected");
          return;
        }

        startReq();
        axios.post('/api/DCApi/saveEnrollments?preReq=' + vm.prereq, {
          students: st,
          courses: cr,
        })
          .then(function (response) {
            endReq();

            if (response.data.status) {
              toastr.success("Saved Successfully", "Done!");
              vm.summary = response.data.summary;
              //$('#tblSummary').DataTable();
              $('#modal-xl').modal('show');
              vm.clear();
            }
            else {
              toastr.error("Internal Error Occured")
            }

          })



      },

      clear() {
        this.sessions = [];
        this.crssessions = [];
        this.st = { ProgramID: 0, SessionID: 0 };
        this.cr = { ProgramID: 0, SessionID: 0 };
        this.students = [];
        this.courses = [];
        this.sections = [];
        this.prereq = false;
        var table = $('#tblStudent').DataTable();
        table.destroy();
        var table = $('#tblCourse').DataTable();
        table.destroy();
      },

      cancel() {
        window.location.reload();
      }

    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/studentCourseEnrollment.vue